var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-video.d6d39724.png","uri@2x": __webpack_public_path__ + "icon-video.d89543ec.png","uri@3x": __webpack_public_path__ + "icon-video.03ea378f.png",
    width: 44,
    height: 30
});